// extracted by mini-css-extract-plugin
module.exports = {"dialog":"HomophonesStyle__dialog--fmaYx","container":"HomophonesStyle__container--22uWt","homophone":"HomophonesStyle__homophone--gf70W","hide":"HomophonesStyle__hide--2fjds"};